export interface Option {
  value: string;
  label: string;
}

export const ROLE_OPTIONS: Option[] = [
  { value: 'unarmed', label: 'Unarmed Officer' },
  { value: 'armed', label: 'Armed Officer' },
  { value: 'supervisor', label: 'Supervisor' },
  { value: 'patrol', label: 'Mobile Patrol' },
  { value: 'event', label: 'Event Security' },
];

export const LOCATION_OPTIONS_FL: Option[] = [
  { value: 'miami-dade', label: 'Miami-Dade' },
  { value: 'broward', label: 'Broward' },
  { value: 'palm-beach', label: 'Palm Beach' },
  { value: 'orlando', label: 'Orlando' },
  { value: 'tampa', label: 'Tampa' },
];

export const LOCATION_OPTIONS_NY: Option[] = [
  { value: 'manhattan', label: 'Manhattan' },
  { value: 'brooklyn', label: 'Brooklyn' },
  { value: 'queens', label: 'Queens' },
  { value: 'bronx', label: 'Bronx' },
  { value: 'staten-island', label: 'Staten Island' },
];

export const ALL_LOCATION_OPTIONS: Option[] = [...LOCATION_OPTIONS_FL, ...LOCATION_OPTIONS_NY];

export const SHIFT_OPTIONS: Option[] = [
  { value: 'day', label: 'Day' },
  { value: 'swing', label: 'Swing' },
  { value: 'night', label: 'Night' },
  { value: '12hour', label: '12-Hour Shifts' },
  { value: 'weekend', label: 'Weekends' },
  { value: 'flexible', label: 'Flexible' },
];

export function mapOptionValues(values: string[], options: Option[]): string[] {
  const map = new Map(options.map((option) => [option.value, option.label]));
  return values.map((value) => map.get(value) ?? value);
}
